<template>
    <div class="emails__list">
        <div class="emails__list_header">
            <view-actions
                :title="'Notifications'"
                :action-button-active="false"
            />
        </div>
        <div class="emails__list_main">
            <component-list
                :component-table="EmailsListTable"
                :component-table-name="'emails'"
                :filter-search-active="true"
                :filter-search-queryable="true"
                :filter-select-active="true"
                :filter-select-items="filtersSelect"
                :get-pagination-getter="'getEmailsPagination'"
                :get-items-getter="'getEmails'"
                :get-items-dispatch="'getEmails'"
                :item-name="['email', 'emails']"
                :table-preferences-active="true"
            />
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import { User } from '@/User'
import EmailsListTable from '@/components/ebs/emails/list/EmailsListTable'
import ComponentList from '@/components/default/shared/ComponentList'

export default {
  name: 'emails-list',
  components: {
    ComponentList,
    ViewActions
  },
  data () {
    return {
      listView: 'table',
      user: new User(),
      outputItems: [],
      EmailsListTable
    }
  },
  computed: {
    filtersSelect () {
      let filtersArr = [
        {
          key: 'category',
          label: 'Category',
          type: 'checkbox',
          preselected: [],
          values: []
        },
        {
          key: 'recipient',
          label: 'Recipient',
          type: 'checkbox',
          values: [
            {
              label: 'Learner',
              value: 'learner'
            },
            {
              label: 'Coordinators',
              value: 'coordinators'
            },
            {
              label: 'Assessor',
              value: 'assessor'
            },
            {
              label: 'Subscribers',
              value: 'subscribers'
            },
            {
              label: 'Trainers',
              value: 'trainers'
            },
            {
              label: 'User',
              value: 'user'
            },
            {
              label: 'Administrators',
              value: 'administrators'
            }
          ]
        },
        {
          key: 'active',
          label: 'Status',
          type: 'checkbox',
          values: [
            {
              label: 'Active',
              value: 'true'
            },
            {
              label: 'Inactive',
              value: 'false'
            }
          ]
        }
      ]

      if (
        this.user.isEventCoordinator() ||
      this.user.isInfrastructureManager() ||
      this.user.isUserAdministrator() ||
      this.user.isMasterAdministrator() ||
      this.user.isLearningExperienceAdministrator() ||
      this.user.isCourseCreator()
      ) {
        if (this.user.hasAnyCustomerService(['EBS', 'DW', 'LMS'])) {
          filtersArr[0].preselected.push('system')
          filtersArr[0].values.push({
            label: 'System',
            value: 'system'
          })
        }
        if (this.user.hasAnyCustomerService(['EBS'])) {
          filtersArr[0].preselected.push('ebs')
          filtersArr[0].values.push({
            label: 'EBS',
            value: 'ebs'
          })
        }
        // if (this.user.hasAnyCustomerService(['CCS'])) {
        //   filtersArr[0].preselected.push('ccm')
        //   filtersArr[0].values.push({
        //     label: 'CCM',
        //     value: 'ccm'
        //   })
        // }
        if (this.user.hasAnyCustomerService(['DW'])) {
          filtersArr[0].preselected.push('dw')
          filtersArr[0].values.push({
            label: 'DW',
            value: 'dw'
          })
        }
      }

      if (this.user.isTokenFromNewLms()) {
        if (this.user.isUserAdministrator() || this.user.isMasterAdministrator()) {
          filtersArr[0].preselected.push('user_management')
          filtersArr[0].values.push({
            label: 'User management',
            value: 'user_management'
          })
        }
      }

      if (this.user.isTokenFromOldLms()) {
        if (
          this.user.isEventCoordinator() ||
        this.user.isInfrastructureManager() ||
        this.user.isDigitalWorkbookAdmin()
        ) {
          filtersArr[0].preselected.push('blue')
          filtersArr[0].values.push({
            label: 'Blue',
            value: 'blue'
          })
          filtersArr[0].preselected.push('dw')
          filtersArr[0].values.push({
            label: 'DW',
            value: 'dw'
          })
        }
      }

      return filtersArr
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/emails/_emailslist.scss";
</style>
